import React, { useContext, useState } from 'react';
import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';

import Ticket from 'app/src/components/Ticket';
import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import ExternalLink from 'app/src/elements/ExternalLink';

const PRIVACY_URL =
  'https://www.termsfeed.com/live/cd6b23e4-3e1b-4a5e-b4f8-f88ed0f8175e';

const Container = styled(View)`
  background-color: ${colors.header};
  padding: 24px;
`;

const FooterTitle = styled(Text)`
  color: ${colors.textOnDark};
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const FooterText = styled(Text)`
  color: ${colors.textOnDarkMuted};
  font-size: 14px;
`;

const Links = styled(View)`
  flex-direction: row;
  justify-content: space-between;
`;

const Footer = () => {
  const { isMobile } = useContext(ClientContext);
  const [showTicket, setShowTicket] = useState(false);

  return (
    <Container>
      <FooterTitle>Keeping.Care</FooterTitle>

      <Links>
        <ExternalLink url={PRIVACY_URL}>
          <FooterText>Privacy Policy</FooterText>
        </ExternalLink>

        <Pressable onPress={() => setShowTicket(true)}>
          <FooterText>Provide Feedback</FooterText>
        </Pressable>
      </Links>

      {showTicket && (
        <Ticket setShow={setShowTicket} />
      )}
    </Container>
  );
};

export default Footer;
